export default __webpack_public_path__ + "af25412338ef8592a0c1d7eb839c586a.mp4";